import { CheckCircle2, ShieldCheck } from "lucide-react";

export function AuthLayout({ children }: { children: React.ReactNode }) {
  return (
    <main className="login-layout">
      <section className="login-story">
        <div className="login-story-grid" />
        <img
          className="login-watermark"
          src="/brand/mira-symbol-white.svg"
          alt=""
          aria-hidden="true"
        />
        <div className="login-brand">
          <img src="/brand/mira-logo-white.svg" alt="Mira Sistemas" />
          <span>Helpdesk</span>
        </div>

        <div className="login-copy">
          <p className="eyebrow eyebrow--light">Suporte que acompanha você</p>
          <h1>
            Tudo o que você precisa,
            <br />
            <em>em um só lugar.</em>
          </h1>
          <p>
            Abra solicitações, acompanhe cada atualização e fale com a equipe
            técnica sem perder o contexto.
          </p>
          <div className="login-points">
            <span><CheckCircle2 /> Histórico completo por chamado</span>
            <span><CheckCircle2 /> Acompanhamento claro de status</span>
            <span><CheckCircle2 /> Comunicação protegida e centralizada</span>
          </div>
        </div>

        <div className="login-trust">
          <ShieldCheck className="size-5" />
          <span>
            <strong>Ambiente seguro</strong>
            Seus dados são protegidos durante toda a sessão.
          </span>
        </div>
      </section>

      <section className="login-panel">
        <div className="login-form-wrap">
          <div className="login-mobile-brand">
            <img src="/brand/mira-logo.svg" alt="Mira Sistemas" />
            <span>Helpdesk</span>
          </div>
          {children}
        </div>
      </section>
    </main>
  );
}
